import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { Badge } from '../UI/Badge/Badge';
import { useFilters } from '../../hooks/useFilters';
import { useGruposConfig } from '../../hooks/useGruposConfig';
import './ActionsTable.css';
import { useState, useEffect } from 'react';
import { useGrupos } from '../../hooks/useGrupos';
import { useURLParams } from '../../hooks/useURLParams';
import Cookies from 'universal-cookie';

export const ActionsTable = ({ toggleFiltros, toggleGrupos }) => {
  const { filtersCount } = useFilters();
  const { countGrupos, updateGrupos, cleanGrupos } = useGruposConfig();
  const { data: groupProperties } = useGrupos();
  const { updateParms, searchParams } = useURLParams();

  const [showAll, setShowAll] = useState(false);
  const [seleccionados, setSeleccionados] = useState(() => {
    const paramGrupos = searchParams.get('grupos');
    return paramGrupos
      ? new Map(
          paramGrupos
            .split(',')
            .map((id) => [
              Number(id),
              { id: Number(id), denomination: '', type: '' },
            ])
        )
      : new Map();
  });

  useEffect(() => {
    const paramGrupos = searchParams.get('grupos');
    const tieneGrupos = paramGrupos && paramGrupos.length > 0;

    if (tieneGrupos && groupProperties) {
      const marcas =
        groupProperties.find((group) => group.type === 'Marca')?.properties ||
        [];

      const idsParam = paramGrupos.split(',').map((id) => Number(id));

      const marcasSeleccionadas = marcas.filter((m) => idsParam.includes(m.id));

      const allMarcasSelected =
        marcas.length > 0 && marcasSeleccionadas.length === marcas.length;

      if (allMarcasSelected) {
        const allMarcasMap = new Map(
          marcas.map((marca) => [
            marca.id,
            {
              id: marca.id,
              denomination: marca.denomination,
              type: 'Marca',
            },
          ])
        );

        setSeleccionados(allMarcasMap);
        updateGrupos(allMarcasMap);
        setShowAll(true);
        const ids = Array.from(allMarcasMap.keys()).join(',');
        updateParms(['grupos', ids, 'pagina', 1]);
      } else {
        const mapSeleccionadas = new Map(
          marcasSeleccionadas.map((marca) => [
            marca.id,
            {
              id: marca.id,
              denomination: marca.denomination,
              type: 'Marca',
            },
          ])
        );
        setSeleccionados(mapSeleccionadas);
        updateGrupos(mapSeleccionadas);
      }
    }
  }, [groupProperties]);

  useEffect(() => {
    const cookies = new Cookies();

    const gruposCookie = cookies.get('grupos');
    if (gruposCookie && gruposCookie.length > 0) {
      const gruposMap = new Map(gruposCookie);
      const marcas =
        groupProperties?.find((g) => g.type === 'Marca')?.properties || [];

      const allMarcasSelected =
        marcas.length > 0 && marcas.every((marca) => gruposMap.has(marca.id));

      setShowAll(allMarcasSelected);

      const gruposIds = Array.from(gruposMap.keys()).join(',');
      updateParms(['grupos', gruposIds, 'pagina', 1]);
    }
  }, [groupProperties]);

  const handleShowAllToggle = () => {
    const newShowAll = !showAll;
    setShowAll(newShowAll);

    if (newShowAll && groupProperties) {
      const marcas =
        groupProperties.find((g) => g.type === 'Marca')?.properties || [];

      const allMarcas = new Map(
        marcas.map((marca) => [
          marca.id,
          { id: marca.id, denomination: marca.denomination, type: 'Marca' },
        ])
      );

      updateGrupos(allMarcas);
      const ids = Array.from(allMarcas.keys()).join(',');
      updateParms(['grupos', ids, 'pagina', 1]);
    } else {
      cleanGrupos();
      updateParms(['grupos', null, 'pagina', 1]);
    }
  };

  return (
    <div className="contenedor__filtro">

      <div class="tooltip">
        <span class="tooltiptext">Aplicar Filtros</span>
        <div className="fg-8">
          <div>{/* <p>Filtros</p> */}</div>
          <div>
            <label
              htmlFor="toggle"
              className="hamburger filter-icon-container"
              onClick={() => toggleFiltros()}
            >
              <FontAwesomeIcon icon={faFilter} size="xl" />
              {filtersCount > 0 && <Badge>{filtersCount}</Badge>}
            </label>
          </div>
        </div>
      </div>
      <div class="tooltip">
        <span class="tooltiptext">Agrupar</span>

        <div className="fg-8">
          <div className="group-toggle-container" onClick={handleShowAllToggle}>
            <FontAwesomeIcon
              icon="fa-solid fa-cubes"
              size="xl"
              className={`group-toggle-icon ${showAll ? 'activo' : ''}`}
            />
          </div>

        </div>
      </div>
    </div>
  );
};
